import React, { PropTypes } from 'react';
// Component
import Card from '../sui/card/Card';
// Styles
import './profile.css';

const propTypes = {
  action: PropTypes.func,
  profile: PropTypes.object.isRequired,
};

const Profile = (props) => {
  const profile = props.profile;
  const src = profile.image
  ? `http://palestra.futurecom.com.br/uploads/pessoas/${profile.image}`
  : 'http://agenda.futurecom.com.br/images/default-user.png';

  const image = {
    src,
    alt: profile.name,
  };

  const contents = [
    {
      header: profile.name,
      meta: <span>{profile.job || ''}</span>,
    },
  ];

  const extraContent = profile.logo &&
  {
    image: {
      extraClasses: 'small logo',
      src: `http://palestra.futurecom.com.br/uploads/empresas/${profile.logo}`,
      alt: profile.company,
    },
  };

  return (
    <Card
      id={profile.id}
      action={props.action}
      image={image}
      contents={contents}
      extraContent={extraContent}
    />
  );
};

Profile.propTypes = propTypes;

export default Profile;



/** WEBPACK FOOTER **
 ** ./src/components/layout/profiles/Profile.js
 **/